import { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import { typeScale } from '../../../shared/styles/typography'

/**
 * 法人版（welcia / aisei）の静的な連絡先文言。
 * /guide（default）は直販の窓口を持つ EscalationContact を使う。
 */
export const ContactNote: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography sx={{ ...typeScale.body, my: 1 }}>{children}</Typography>
)
